<nb-flip-card [showToggleButton]="false" [flipped]="flipped">
  <nb-card-front>
    <nb-card size="small">
      <div
        class="picture"
        [style.background-image]="'url(' + imageURL + ')'"
        (click)="onFrontClick()"
      ></div>

      <nb-icon
        icon="chevron-right-outline"
        pack="eva"
        class="flip-icon"
        (click)="toggleView()"
      ></nb-icon>

      <div class="summary">
        <ngx-view-rating-star
          [rating]="course.rating"
          [noRating]="course.noRating"
        ></ngx-view-rating-star>

        <div class="item">
          <div class="avatar">
            <nb-user
              [picture]="
                course.author
                  ? course.author.photoURL
                  : '/assets/images/default_avatar.jpg'
              "
              size="large"
              (click)="onFrontClick()"
              onlyPicture
              style="cursor: pointer"
            ></nb-user>
          </div>

          <div class="content">
            <h6 *ngIf="course.title" class="text-link">
              <a class="link" (click)="onFrontClick()">
                {{ course.title }}
              </a>
            </h6>
          </div>
        </div>
      </div>

      <nb-card-footer *ngIf="mode === 'student'">
        <button
          *ngIf="value == 0"
          nbButton
          size="tiny"
          status="success"
          shape="round"
          (click)="onClick()"
        >
          <nb-icon icon="star"></nb-icon> <span>Bắt đầu</span>
        </button>

        <nb-progress-bar
          (click)="onClick()"
          *ngIf="value > 0"
          [value]="value"
          [status]="status"
        >
          {{ value }}%
        </nb-progress-bar>
      </nb-card-footer>

      <nb-card-footer *ngIf="mode !== 'student'">
        <nb-actions size="none">
          <nb-action>
            <nb-icon
              [status]="'danger'"
              class="action-icon"
              icon="heart-outline"
            ></nb-icon>
            <span>{{ course.hearts ? course.hearts : "." }}</span>
          </nb-action>

          <nb-action>
            <nb-icon
              [status]="course.noStudent ? 'success' : 'danger'"
              class="action-icon"
              icon="people-outline"
            ></nb-icon>
            <span>{{ course.noStudent ? course.noStudent : "." }}</span>
          </nb-action>
        </nb-actions>

        <nb-actions size="none">
          <nb-action>
            <nb-icon
              [status]="'info'"
              class="action-icon"
              icon="menu-2-outline"
            ></nb-icon>
            <span>{{ course.noSection ? course.noSection : "0" }}</span>
          </nb-action>

          <nb-action>
            <nb-icon
              [status]="'info'"
              class="action-icon"
              icon="book-open-outline"
            ></nb-icon>
            <span>{{ course.noLecture ? course.noLecture : "0" }}</span>
          </nb-action>
        </nb-actions>
      </nb-card-footer>
    </nb-card>
  </nb-card-front>

  <nb-card-back>
    <nb-card size="small">
      <nb-card-body (click)="toggleView()">
        <div class="details">
          <p>
            <strong>Khóa học:</strong><br />
            {{ course.title }}<br />
          </p>
          <p>
            <strong>Mô tả:</strong><br />
            <span style="white-space: pre-line">{{ course.description }}</span>
          </p>

          <p>
            <strong>Mục đích:</strong><br />
            <span style="white-space: pre-line">{{ course.purpose }}</span
            ><br />
          </p>

          <p><strong>Hướng dẫn:</strong></p>
          <nb-user
            [picture]="
              course.author
                ? course.author.photoURL
                : '/assets/images/default_avatar.jpg'
            "
            name="{{ course.authorName }}"
            size="large"
            style="cursor: pointer"
          ></nb-user>
        </div>
      </nb-card-body>
      <nb-icon
        icon="chevron-right-outline"
        pack="eva"
        class="flip-icon"
        (click)="toggleView()"
      ></nb-icon>
      <nb-card-footer>
        <button
          nbButton
          size="small"
          status="primary"
          shape="semi-round"
          (click)="onClick()"
        >
          <nb-icon icon="star"></nb-icon> Xem nội dung
        </button>
      </nb-card-footer>
    </nb-card>
  </nb-card-back>
</nb-flip-card>
